import { React, Component } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Sidebar() {
  const navigate = useNavigate();

  let location = window.location.href.split('/')[window.location.href.split('/').length - 1];

  const activeClass = (page) => {
    return location === page ? "nav-link" : "nav-link collapsed";
  }

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };



  return (

    <>{/* ======= Sidebar ======= */}
      <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">

          <li className="nav-heading">HOME</li>

          <li className="nav-item">
            <Link to="/dashboard" className={activeClass("dashboard")}>
              <i className="bi bi-grid" />
              <span>Dashboard</span>
            </Link>
          </li>

          <li className="nav-heading">COMMERCE</li>

          <li className="nav-item">
            <Link to="/customers" className={activeClass("customers")}>
              <i className="bi bi-people" />
              <span>Customers</span>
            </Link>
          </li>

          {/* <li className="nav-item">
            <Link to="/virtual-cards" className={activeClass("virtual-cards")}>
              <i className="bi bi-credit-card" />
              <span>Virtual Cards</span>
            </Link>
          </li> */}

          <li className="nav-item">
            <Link to="/deposits" className={activeClass("deposits")}>
              <i className="bi bi-wallet2" />
              <span>Deposits</span>
            </Link>
          </li>

          <li className="nav-item">
            <Link to="/withdrawals" className={activeClass("withdrawals")}>
              <i className="bi bi-receipt" />
              <span>Withdrawals</span>
            </Link>
          </li>

          <li className="nav-heading">Cryptocurrency</li>

          <li className="nav-item">
            <Link to="/crypto-wallets" className={activeClass("crypto-wallets")}>
              <i className="bi bi-wallet" />
              <span>Wallets</span>
            </Link>
          </li>

          {/* <li className="nav-item">
            <Link to="/transactions" className={activeClass("transactions")}>
              <i className="bi bi-list" />
              <span>Transactions</span>
            </Link>
          </li> */}

          <li className="nav-heading">Settings</li>


          {/* <li className="nav-item">
              <a className="nav-link collapsed" href="">
                <i className="bi bi-sliders" />
                <span>Permissions</span>
              </a>
            </li> */}

          <li className="nav-item">
            <a className="nav-link collapsed" href="">
              <i className="bi bi-info-circle" />
              <span>Support</span>
            </a>
          </li>

        </ul>

      </aside>{/* End Sidebar*/}</>
  );
}
export default Sidebar;